import React, { useEffect, Suspense, lazy } from 'react';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import { AnimatePresence } from "framer-motion";

function App() {
  const location = useLocation();

  const Home = lazy(() => import("./components/Home"));

  const About = lazy(() => import("./components/Bio"));
  const Contact = lazy(() => import("./components/Contact"));
  const ErrorPage = lazy(() => import("./components/ErrorPage"));

  /* Graphic & Web Design */
  const GW_Design = lazy(() => import("./components/categories/GW_Design"));
  const StitchNote = lazy(() => import("./components/categories/graphicDesign/StitchNote"));
  const Magazine = lazy(() => import("./components/categories/graphicDesign/Magazine"));
  const DeVsHoney = lazy(() => import("./components/categories/graphicDesign/DeVsHoney"));
  const Maison = lazy(() => import("./components/categories/graphicDesign/Maison"));

  /* Animation & Motion */
  const Anim_Mo = lazy(() => import("./components/categories/Anim_Mo"));
  const IntroToAnimation = lazy(() => import("./components/categories/animation/IntroToAnimation"));
  const FPSSteeringSystem = lazy(() => import("./components/categories/animation/FPSSteeringSystem"));

  /* Interactive Development */
  const Inter_Dev = lazy(() => import("./components/categories/Inter_Dev"));

  // Cyberpunk 2077 Game Modification
  const PracticeMakesPerfect = lazy(() => import("./components/categories/interactive/PracticeMakesPerfect"));
  const PersonalMechanics = lazy(() => import("./components/categories/interactive/PersonalMechanics"));

  // Threejs Projects
  const HalftoneShader = lazy(() => import("./components/threejsProjects/halftoneShader/HalftoneShader"));
  const EarthShader = lazy(() => import("./components/threejsProjects/earthShader/EarthShader"));
  const ParticleIntShader = lazy(() => import("./components/threejsProjects/particlesInteraction/ParticlesShader"));
  const MorphShader = lazy(() => import("./components/threejsProjects/morphingParticleShader/MorphShader"));
  const BottleFluidShader = lazy(() => import("./components/threejsProjects/bottleFluidShader/BottleFluidShader"));
  const FlowShader = lazy(() => import("./components/threejsProjects/gpgpuFlowFieldParticleShader/FlowShader"));
  const LiquidSphere = lazy(() => import("./components/threejsProjects/LiquidSphere/LiquidSphereShader"));
  const SlicedModel = lazy(() => import("./components/threejsProjects/SlicedModel/SlicedModelShader"));
  const ProceduralTerrain = lazy(() => import("./components/threejsProjects/proceduralTerrain/ProceduralTerrainShader"));

    /* Visual Media */
  const Visual_Media = lazy(() => import("./components/categories/Visual_Media"));
  const Creso = lazy(() => import("./components/categories/media/Creso"));
  const MoodyFilms = lazy(() => import("./components/categories/media/MoodyFilms"));
  const Photography = lazy(() => import("./components/categories/media/Photography"));

  return (
    <Suspense fallback={<div className="loading">Loading...</div>}>
      <AnimatePresence mode="wait">
        {/* <RouterProvider future={{v7_startTransition: true}} router={router} /> */}
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<Home />} />
          <Route path="/bio" element={<About />} />
          <Route path="/contact" element={<Contact />} />

          {/* Graphic & Web Design */}
          <Route path="/categories/gw_design" element={<GW_Design />} />
            <Route path="/categories/graphicDesign/stitchnote" element={<StitchNote />} />
            <Route path="/categories/graphicDesign/magazine" element={<Magazine />} />
            <Route path="/categories/graphicDesign/devshoney" element={<DeVsHoney />} />
            <Route path="/categories/graphicDesign/maison" element={<Maison />} />

          {/* Animation & Motion */}
          <Route path="/categories/anim_mo" element={<Anim_Mo />} />
            <Route path="/categories/animation/IntroToAnimation" element={<IntroToAnimation />} />
            <Route path="/categories/animation/FPSSteeringSystem" element={<FPSSteeringSystem />} />

          {/* Interactive Development */}
          <Route path="/categories/inter_dev" element={<Inter_Dev />} />

            {/* Cyberpunk 2077 Mods */}
            <Route path="/categories/interactive/PracticeMakesPerfect" element={<PracticeMakesPerfect />} />
            <Route path="/categories/interactive/PersonalMechanics" element={<PersonalMechanics />} />

            {/* Three.js Projects */}
              <Route path="/threejs/halftone-shader" element={<HalftoneShader />} />
              <Route path="/threejs/earth-shader" element={<EarthShader />} />
              <Route path="/threejs/particleint-shader" element={<ParticleIntShader />} />
              <Route path="/threejs/morph-shader" element={<MorphShader />} />
              <Route path="/threejs/bottle-shader" element={<BottleFluidShader />} />
              <Route path="/threejs/flow-particles" element={<FlowShader />} />
              <Route path="/threejs/liquid-sphere" element={<LiquidSphere />} />
              <Route path="/threejs/sliced-model" element={<SlicedModel />} />
              <Route path="/threejs/procedural-terrain" element={<ProceduralTerrain />} />

          {/* Visual Media */}
          <Route path="/categories/visual_media" element={<Visual_Media />} />
            <Route path="/categories/media/creso" element={<Creso />} />
            <Route path="/categories/media/moodyfilms" element={<MoodyFilms />} />
            <Route path="/categories/media/photography" element={<Photography />} />

          {/* <Route path="/project01" element={<Project01 />} />
          */}

          <Route path="*" element={<ErrorPage />} /> {/* Catch-all for invalid URLs */}
        </Routes>
      </AnimatePresence>
    </Suspense>
  );
}

export default App;
